// for All Transaction
export const tranTypeList1 = [
  { value: 'Debit Adjustment', code: 'A' },
  { value: 'Credit Adjustment', code: 'B' },
  { value: 'Receipt', code: 'Y' },
  { value: 'Payment', code: 'Z' },
  { value: 'Direct Business Debit Note', code: 'M' },
  { value: 'Coinsurance Outward Debit Note', code: 'N' },
  { value: 'Reinsurance Inward Debit Note', code: 'O' },
  { value: 'Reinsurance Outward Debit Note', code: 'P' },
  { value: 'Miscellaneous Debit Note', code: 'Q' },
  { value: 'Direct Business Credit Note', code: 'R' },
  { value: 'Coinsurance Outward Credit Note', code: 'S' },
  { value: 'Reinsurance Inward Credit Note', code: 'T' },
  { value: 'Reinsurance Outward Credit Note', code: 'U' },
  { value: 'Miscellaneous Credit Note', code: 'V' },
  { value: 'Claims Debit Note', code: 'W' },
  { value: 'Claims Credit Note', code: 'X' }
]

// for Account Transactions
export const tranTypeList2 = [
  { value: 'Debit Adjustment', code: 'A' },
  { value: 'Credit Adjustment', code: 'B' },
  { value: 'Receipt', code: 'Y' },
  { value: 'Payment', code: 'Z' }
]

// for Underwriting Transactions
export const tranTypeList3 = [
  { value: 'Direct Business Debit Note', code: 'M' },
  { value: 'Coinsurance Outward Debit Note', code: 'N' },
  { value: 'Reinsurance Inward Debit Note', code: 'O' },
  { value: 'Reinsurance Outward Debit Note', code: 'P' },
  { value: 'Miscellaneous Debit Note', code: 'Q' },
  { value: 'Direct Business Credit Note', code: 'R' },
  { value: 'Coinsurance Outward Credit Note', code: 'S' },
  { value: 'Reinsurance Inward Credit Note', code: 'T' },
  { value: 'Reinsurance Outward Credit Note', code: 'U' },
  { value: 'Miscellaneous Credit Note', code: 'V' }
]

// for Claims Transactions
export const tranTypeList4 = [
  { value: 'Claims Debit Note', code: 'W' },
  { value: 'Claims Credit Note', code: 'X' }
]

// Intermediary Group
export const interGrpList = [
  { value: 'Agent', code: '10', codeValue: '10 - Agent' },
  { value: 'Broker', code: '11', codeValue: '11 - Broker' },
  { value: 'Financial Institution', code: '12', codeValue: '12 - Financial Institution' },
  { value: 'Cedant/Reinsurer', code: '20', codeValue: '20 - Cedant/Reinsurer' },
  { value: 'Direct Client', code: '25', codeValue: '25 - Direct Client' },
  { value: 'Loss Adjuster', code: '30', codeValue: '30 - Loss Adjuster' },
  { value: 'Repairer', code: '31', codeValue: '31 - Repairer' },
  { value: 'Solicitor', code: '32', codeValue: '32 - Solicitor' },
  { value: 'Forensic', code: '33', codeValue: '33 - Forensic' },
  { value: 'Survey Agent', code: '34', codeValue: '34 - Survey Agent' },
  { value: 'Settling Agent', code: '35', codeValue: '35 - Settling Agent' },
  { value: 'Contractor', code: '40', codeValue: '40 - Contractor' },
  { value: 'Guarantor', code: '41', codeValue: '41 - Guarantor' },
  { value: 'Third Party', code: '50', codeValue: '50 - Third Party' },
  { value: 'Supplier', code: '60', codeValue: '60 - Supplier' },
  { value: 'Other', code: '70', codeValue: '70 - Other' }
]
